<template>
	<div>
        <div class="list-content">
              <div>
                <img class="image_div" :src="itemChild.bookLogoUrl" mode="" />
                <span class="book_name">{{ itemChild.bookName }}</span>
              </div>
          </div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		name: 'three_conpontent',
		props: {
            itemChild:{
				type: Object,
				default: {
                }
            }
		},
		data() {
			return {
			};
		},
		watch: {
			// current(val) {
			// 	if (val !== this.currentIndex) {
			// 		this.currentIndex = val;
			// 	}
			// }
		},
		methods: {
			
		},
		created() {
		}
	};
</script>

<style  scoped>
.list-content {
  display: flex;
  width: 100%;
}
 .image_div {
  display: block;
  width: 96px;
  height: 128px;
  /* width: 1.9rem;
   height: 2.52rem; */
  border-radius: 6px;
}

 .book_name {
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  width: 96px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/book_item/three_compontent.vue